import React from 'react'

import Line from './Line'
import Separator from './Separator'

const LineSeparator = ({ weight, ...props }) => {
  const commonProps = { weight }

  return (
    <>
      <Separator {...commonProps} />
      <Line {...props} />
      <Separator {...commonProps} />
    </>
  )
}

export default LineSeparator
